import { render, staticRenderFns } from "./ObjectGroupCard.vue?vue&type=template&id=abd94938&scoped=true&"
import script from "./ObjectGroupCard.vue?vue&type=script&lang=js&"
export * from "./ObjectGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGroupCard.vue?vue&type=style&index=0&id=abd94938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd94938",
  null
  
)

export default component.exports